import { all, fork } from "redux-saga/effects";

//auth
import authSaga from "./auth/saga";
import layoutSaga from "./layout/saga";
import organisationSaga from "./organisation/sagas";
import loadEmployeeSaga from "./Employee/sagas";
import loadLeaveDetailsSaga from "./LeaveAndPermission/sagas";
import attendenceSaga from "./Attendence/sagas";
import loadEmployeeLeaveRecordSaga from "./Reports/sagas";
import dashboardSaga from "./Dashboard/sagas"
import locationSaga from "./Location/sagas"
import masterSaga from './Masters/sagas'
import projectSaga from "./Project/saga"

export default function* rootSaga() {
  yield all([
    fork(authSaga),
    fork(layoutSaga),
    fork(organisationSaga),
    fork(loadEmployeeSaga),
    fork(loadLeaveDetailsSaga),
    fork(attendenceSaga),
    fork(loadEmployeeLeaveRecordSaga),
    fork(dashboardSaga),
    fork(locationSaga),
    fork(masterSaga),
    fork(projectSaga)
  ]);
}
